<template>
    <section class="flex flex-col gap-6">
        <header>
            <AssessmentEyebrow>Before you start</AssessmentEyebrow>
            <h1 class="display-serif text-valence-grey-850 leading-tight mt-3">{{ heading }}</h1>
            <p v-if="meta" class="details text-valence-grey-750 mt-2">{{ meta }}</p>
        </header>

        <MarkdownText v-if="intro.purpose" :text="intro.purpose" class="body text-valence-grey-750 leading-relaxed" />

        <div v-if="cards.length" class="grid grid-cols-1 gap-3" :class="cardGridClass">
            <BaseCard v-for="(card, index) in cards" :key="index" padding="sm">
                <div class="body-small-bold text-valence-grey-850">{{ card.title }}</div>
                <MarkdownText v-if="card.body" :text="card.body" class="details text-valence-grey-750 mt-0.5" />
            </BaseCard>
        </div>

        <div class="flex justify-end">
            <BaseButton theme="primary" @click="emit('begin')">Begin <i class="bi bi-arrow-right" aria-hidden="true"></i></BaseButton>
        </div>
    </section>
</template>

<script setup lang="ts">
import type { AssessmentIntro } from "~vue/api/generated/reflections";
import AssessmentEyebrow from "~vue/components/AssessmentEyebrow.vue";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import { computed } from "vue";

interface Props {
    intro: AssessmentIntro;
}

const props = defineProps<Props>();
const emit = defineEmits<{ begin: [] }>();

const heading = computed(() => props.intro.heading || "Welcome");
const cards = computed(() => props.intro.cards ?? []);
const cardGridClass = computed(() => (cards.value.length >= 3 ? "sm:grid-cols-3" : cards.value.length === 2 ? "sm:grid-cols-2" : "sm:grid-cols-1"));

const meta = computed(() => {
    const parts: string[] = [];
    const questionCount = props.intro.question_count ?? 0;
    if (questionCount > 0) {
        parts.push(`${questionCount} ${questionCount === 1 ? "question" : "questions"}`);
    }
    const minutes = props.intro.estimated_minutes ?? 0;
    if (minutes > 0) {
        parts.push(`about ${minutes} min`);
    }
    return parts.join(" · ");
});
</script>
